import { AttributeOptionEditorComponent } from './../../attribute-option-editor/attribute-option-editor.component';
import { ConfigAttribute } from './../../../types/project-config';
import { AttributeConditionsDialogService } from './../attribute-conditions-dialog/attribute-conditions-dialog.service';
import { TypedHandler } from './../../../types/handlers';
import { ModalMessagerService } from './../modal-messager/modal-messager.service';
import { AttributeConditionsDialogEntryComponent } from './../attribute-conditions-dialog/attribute-conditions-dialog.component';
import { SubscriptionMgr } from 'app/model/SubscriptionMgr';
import { NgbModal, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild } from '@angular/core';
import { ObjID } from 'app/model/id-manager';
import { AttributeOption, Costs } from 'app/types/project-config';
import { AttributeOptionEditorDialogService } from './attribute-option-editor-dialog.service';
import { Project } from 'app/model/project';

export type AttributeOptionEditorDialogParams = {
  project: Project,
  attribute: ConfigAttribute,
  option?: AttributeOption;
  handler?: TypedHandler<AttributeOption | undefined>;
}

@Component({
  selector: 'app-attribute-option-editor-dialog-entry',
  templateUrl: './attribute-option-editor-dialog-entry.component.html',
  styleUrls: ['./attribute-option-editor-dialog-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AttributeOptionEditorDialogEntryComponent implements OnInit {
  constructor(private modal: NgbActiveModal, private messager: ModalMessagerService, private cdr: ChangeDetectorRef) { }

  public option?: AttributeOption;
  private handler?: TypedHandler<AttributeOption | undefined>;
  public project?: Project;
  public attribute?: ConfigAttribute;
  @ViewChild('editor', { static: true }) editor?: AttributeOptionEditorComponent;
  ngOnInit(): void {
  }
  Show(config: AttributeOptionEditorDialogParams) {
    if (config.handler) {
      this.handler = config.handler;
    }
    if (config.option) {
      this.option = config.option;
    }
    if (!!config.project) {
      this.project = config.project;
    }
    if (!!config.attribute) {
      this.attribute = config.attribute;
    }

    this.cdr.markForCheck();
    this.cdr.detectChanges();
  }
  FromOption(option: AttributeOption) {

  }
  Hide() {
    this.modal.close();
  }
  Ok() {
    if (!this.editor) return;
    const option = this.editor.GetOption();
    if (option && this.attribute) {
      if (!this.attribute.options) this.attribute.options = [];
    }
    if (option && this.attribute && this.attribute.options) {
      for (const extantOption of this.attribute.options) {
        if (extantOption.id === option.id) {
          if (this.handler) this.handler(option);
          this.Hide();
          return;
        }
      }
      this.attribute.options.push(option)
    }

    if (this.handler) {
      this.handler(option);
    }
    this.Hide();

  }
  Cancel() {
    this.Hide();
  }
}

@Component({
  selector: 'app-attribute-option-editor-dialog',
  template: ''
})
export class AttributeOptionEditorDialogComponent implements OnInit {
  modalRef?: NgbModalRef;
  subscriptionMgr: SubscriptionMgr = new SubscriptionMgr();
  lastTitle: string | null = null;
  constructor(private modalService: NgbModal, private service: AttributeOptionEditorDialogService) {

    this.subscriptionMgr.Subscribe(this.service.requests, (config: AttributeOptionEditorDialogParams) => {
      this.modalRef = this.modalService.open(AttributeOptionEditorDialogEntryComponent, { backdrop: 'static', modalDialogClass: 'attribute-option-editor-dialog' });
      (this.modalRef.componentInstance as AttributeOptionEditorDialogEntryComponent).Show(config);
    });
  }
  ngOnInit(): void {
  }
  ngOnDestroy() {
    this.subscriptionMgr.CancelSubscriptions();
  }
}
